import broadcast from "../../app/broadcast";


/**
 * Clase que controla la lógica de un controlador de filtro de advertencias.
 * @class
 */
class CBWarningsFilterController{

    /**
     * Constructor de la clase CBWarningsFilterController.
     * @constructor
     * @param {CheckBoxView} view - Instancia de la vista del filtro de advertencias.
     * @param {number} risk - Nivel de riesgo asociado al filtro.
     */
    constructor(view, risk) {
        /**
         * Vista asociada al controlador.
         * @type {CheckBoxView}
         * @private
         */
        this.view = view;
        /**
         * Nivel de riesgo asociado al filtro.
         * @type {number}
         * @private
         */
        this.risk = risk;

        // Establece el estado inicial del checkbox como marcado.
        this.view.checkbox.checked = true;

        // Añade un listener para el evento de cambio en el checkbox.
        this.view.checkbox.addEventListener("change", this.change.bind(this));

    }

    /**
     * Método que maneja el cambio en el estado del checkbox y emite un evento de filtro de advertencias.
     * @private
     */
    change() {
        // Emite un evento warningsfilter con el nivel de riesgo y el estado del checkbox.
        broadcast.emit("warningsfilter", this.risk, this.view.checkbox.checked);
    }

}

export default CBWarningsFilterController;
